import {
  type ECommerceEventIdentity,
  type PurchaseEvent,
  purchaseEventSchema
} from './eCommerceTrackingEventSchema';
import { getCatalogSourceTrackingData } from './catalogSourceStorage';
import logger from '../logger';
import { safeParse } from 'zod';

export type PurchaseEventProps = Omit<
  PurchaseEvent,
  'anonymousId' | 'authenticatedId' | 'event_name' | 'event'
>;
export type PurchaseEventWithIdentityProps = ECommerceEventIdentity & PurchaseEventProps;

export const buildPurchaseEvent = (props: PurchaseEventWithIdentityProps): PurchaseEvent => {
  const { anonymousId, authenticatedId, ecommerce } = props;

  const purchaseEvent: PurchaseEvent = {
    event: 'ga4_event_ecommerce',
    event_name: 'purchase',
    anonymousId,
    authenticatedId,
    ecommerce: { ...ecommerce, ...getCatalogSourceTrackingData() }
  };

  const result = safeParse(purchaseEventSchema, purchaseEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid purchase event');
  }

  return purchaseEvent;
};
